// eslint-disable-next-line
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { filterConditionState } from '../../../redux/reducers/CurrentFilterReducer';
import { SearchConditionState } from '../../../redux/reducers/SearchConditionReducer';
import Table from '../../atoms/Table';
import { SCREEN } from '../../../Common';
import moment from 'moment';
import { GASpotEventState } from '../../organisms/NegotiationCountList';

export interface CustomCountTableHandler {
  updateFilterCondition(state: filterConditionState): void;
  updateSearchCondition(state: SearchConditionState, isNotFilter: boolean): void;
}
interface TableProps extends CustomCountTableHandler {
  total: number | string;
  doing: number | string;
  pendinng: number | string;
  done: number | string;
  jobDateTime?: string;
  filterConditions: filterConditionState;
  gaSpotEvent?: GASpotEventState;
}

class CustomCountTable extends Component<TableProps, any> {
  constructor(props: TableProps) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    // 現在のフィルタを適用
    this.props.updateFilterCondition(this.props.filterConditions);

    // 現在のフィルタに紐づく検索条件を適用
    const searchConditions = this.props.filterConditions.searchConditions;

    let searchConditionCopy: SearchConditionState = [];
    searchConditions.forEach((searchItem) => {
      searchConditionCopy.push({
        searchConditionGroupId: 1,
        searchConditionName: searchItem.searchConditionName,
        specifiedCondition: searchItem.specifiedCondition,
      });
      searchConditionCopy.push({
        searchConditionGroupId: 2,
        searchConditionName: searchItem.searchConditionName,
        specifiedCondition: searchItem.specifiedCondition,
      });
    })
    searchConditions.push.apply(searchConditions, searchConditionCopy);

    // Step1. GroupId「2」条件
    // Step1-1. 検索条件[undispFlg]を追加
    searchConditions.push({
      searchConditionGroupId: 2,
      searchConditionName: 'undispFlg',
      specifiedCondition: ['0'],
    });
    // Step1-2. 検索条件[negotiationStatusType]を追加
    searchConditions.push({
      searchConditionGroupId: 2,
      searchConditionName: 'negotiationResultType',
      specifiedCondition: ['01','02','03','05'],
    });

    // Step2. GroupId「1」条件
    // Step2-1. 検索条件[resurrectionFlg]を追加
    searchConditions.push({
      searchConditionGroupId: 1,
      searchConditionName: 'resurrectionFlg',
      specifiedCondition: ['1'],
    });
    // Step2-2. 検索条件[undispFlg]を追加
    searchConditions.push({
      searchConditionGroupId: 1,
      searchConditionName: 'undispFlg',
      specifiedCondition: ['1'],
    });

    // Step3. GroupId「0」条件
    // Step3-1. 検索条件[undispFlg]を追加
    searchConditions.push({
      searchConditionGroupId: 0,
      searchConditionName: 'undispFlg',
      specifiedCondition: ['0'],
    });
    // Step3-2. 検索条件[negotiationStatusType]を追加
    searchConditions.push({
      searchConditionGroupId: 0,
      searchConditionName: 'negotiationResultType',
      specifiedCondition: ['00','07'],
    });
    // 長期保留月計算
    if (this.props.jobDateTime) {
      let dStr = this.props.jobDateTime.replace(/^([0-9]{4})([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{2})$/, '$1/$2/$3 $4:$5:$6');
      let monthAdd5 = moment(dStr).add(5, 'months').startOf('month').subtract(1, 'days').format('YYYYMMDD');
      // Step3-3. 検索条件[actionDate]を追加
      searchConditions.push({
        searchConditionGroupId: 0,
        searchConditionName: 'actionDate',
        specifiedCondition: [null, monthAdd5],
      });
    }
    // actionType取得
    const actionTypeIndex = searchConditions.findIndex((element) => element.searchConditionName === 'actionType');
    // 架電予定以外の場合
    if (actionTypeIndex === -1) {
      // Step3-4. 検索条件[actionInfo]を追加
      searchConditions.push({
        searchConditionGroupId: 0,
        searchConditionName: 'actionInfo',
        specifiedCondition: [null],
      });
    }

    this.props.updateSearchCondition(searchConditions, false);
  }

  componentDidMount(): void {
    const { gaSpotEvent } = this.props;
    if (!gaSpotEvent) return;
    document.querySelector(`.${gaSpotEvent.className}`)?.setAttribute('onclick', `${gaSpotEvent.spotEvent}`);
  }

  render() {
    // valueはstateに
    const tablesHeader = {
      key: 'total',
      name: '合計',
      value: this.props.total,
    };
    const tablesRows = [
      {
        key: 'doing',
        name: '商談中',
        value: this.props.doing,
      },
      {
        key: 'pending',
        name: '長期保留',
        value: this.props.pendinng,
      },
      {
        key: 'done',
        name: '商談終了',
        value: this.props.done,
      },
    ];

    return (
      <Table className='custom-count-table u-w-full u-mt8'>
        <Table.THead>
          <Table.Tr className='custom-count-table__header-row'>
            <Table.Th>{tablesHeader.name}</Table.Th>
            <Table.Th className='u-text-right'>
              <Link
                className={`u-text-underline ${this.props.gaSpotEvent?.className || ''}`}
                to={`${SCREEN.NEGOTIATION_SEARCH_RESULT.URL}`}
                onClick={() => this.handleClick()}
                data-testid-e2e={`customCountTable-value-${tablesHeader.key}`}>
                {tablesHeader.value}
              </Link>
            </Table.Th>
          </Table.Tr>
        </Table.THead>
        <Table.TBody>
          {tablesRows.map((row) => (
            <Table.Tr key={row.key} className='custom-count-table__row'>
              <Table.Td>{row.name}</Table.Td>
              <Table.Td className='u-text-right' data-testid-e2e={`customCountTable-value-${row.key}`}>
                {row.value}
              </Table.Td>
            </Table.Tr>
          ))}
        </Table.TBody>
      </Table>
    );
  }
}

export default CustomCountTable;
